module.exports = __webpack_public_path__ + "static/media/1-20.7b0ce17a.mp3";